import { useEffect } from "react";

import { useFormContext } from "react-hook-form";

import Box from "@/components/Box";
import Checkbox from "@/tpo/Checkbox";
import ControlledFormField from "@/tpo/ControlledFormField";

export function PatientOrderPermission({ previouslyGranted = false }) {
  const { watch, setValue } = useFormContext();
  const level = watch("level");

  useEffect(() => {
    if (previouslyGranted) {
      setValue("patientOrderPermission", true);
    }
  }, [previouslyGranted, setValue]);

  if (level !== "Level 6") return null;

  return (
    <>
      <ControlledFormField
        Component={Checkbox}
        label="I have permission to order on behalf of a patient"
        name="patientOrderPermission"
        disabled={previouslyGranted}
        styles={{
          checkbox: {
            size: "sm"
          }
        }}
      />
      <Box fontSize={12} fontFamily="gilroyMedium">
        *Patient access requires permission from your college, please confirm to enable this feature
      </Box>
    </>
  );
}
